/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 */

/**
 * Google Map Configuration
 */
export const googleMapConfig = {
  apiKey: 'AIzaSyA3ZOPvAXX71qX8isbVWNvBq3PjSNi6JCo',
};
